import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { CapitalizePipe } from './capitalize.pipe';
import { FormatCardExpiryPipe } from './credit-card/format-card-expiry.pipe';
import { MaskCardNumberPipe } from './credit-card/mask-card-number.pipe';
import { CustomFieldParseValuePipe } from './custom-field-parse-value.pipe';
import { DecimalPlacesPipe } from './decimal-places.pipe';
import { FilterControlsPipe } from './filter-controls.pipe';
import { FormControlGetterPipe } from './form-control-getter.pipe';
import { HtmlSanitizerPipe } from './html-sanitizer.pipe';
import { LumCurrencyPipe } from './lum-currency.pipe';
import { MapEnumTextPipe } from './map-enum-text.pipe';
import { NumberFormatPipe } from './number-format.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { RemoveHtmlPipe } from './remove-html.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SnakeCaseToTitleCase } from './snake-case-to-title-case.pipe';
import { SortByDatePipe } from './sort-by-date.pipe';
import { SortByPipe } from './sort-by.pipe';
import { TableRowPipe } from './table-row.pipe';
import { UniqueByPipe } from './unique-by.pipe';
import { UnitAbbreviationPipe } from './unit-abbreviation.pipe';
import { ValidationPipe } from './validation.pipe';

const pipes = [
  TableRowPipe,
  FormControlGetterPipe,
  SortByDatePipe,
  SortByPipe,
  HtmlSanitizerPipe,
  ValidationPipe,
  FilterControlsPipe,
  SafeHtmlPipe,
  CustomFieldParseValuePipe,
  RemoveHtmlPipe,
  CapitalizePipe,
  NumberFormatPipe,
  FormatCardExpiryPipe,
  MaskCardNumberPipe,
  SnakeCaseToTitleCase,
  MapEnumTextPipe,
  RelativeTimePipe,
  UniqueByPipe,
  DecimalPlacesPipe,
  LumCurrencyPipe,
  UnitAbbreviationPipe,
];

const providers = [DatePipe, CurrencyPipe];

@NgModule({
  declarations: [...pipes],
  providers: [...pipes, ...providers],
  imports: [CommonModule],
  exports: [...pipes],
})
export class PipeModule {}
